import React, { FC } from 'react';
import { Redirect, useParams } from 'react-router';
import { useUser } from '../../shared';
import { useClientRoutesContext } from 'src/config/clientRoutes/hooks';
import { UrlParams } from 'src/modules/shared/types';

const LoggedInFallBackPage: FC = () => {
  const { isStudent } = useUser();
  const routes = useClientRoutesContext();
  let params = useParams<UrlParams>();
  const { bookId } = params;

  const checkRedirect = () => {
    console.log('LoggedInFallBackPage', window.location);
    if (bookId) {
      console.log('1');
      return routes.bookOverview;
    } else {
      console.log('2');
      return routes.book;
    }
  };

  if (isStudent) return <Redirect to={routes.studentDashboard} />;

  if (window.location.href.indexOf('sso?token') !== -1) {
    console.log('still have the redirect url ', window.location.href);
    return null;
  }

  return <Redirect to={checkRedirect()} />;
};

export default LoggedInFallBackPage;
